import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
export const slideNodesAdapter = createEntityAdapter({
  selectId: slideNode => slideNode.sId.toString()
});
const initialState = slideNodesAdapter.getInitialState();
const slideNodesSlice = createSlice({
  name: "slideNodes",
  initialState,
  reducers: {
    // Added to, not replaced, as the side panel keeps the annotations of several sheets loaded
    upsertSlideNodes: slideNodesAdapter.upsertMany,
    resetSlideNodesState: () => initialState
  }
});
export const {
  upsertSlideNodes,
  resetSlideNodesState
} = slideNodesSlice.actions;
export const slideNodesReducer = slideNodesSlice.reducer;